import React from "react";
import moment from "moment";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import PdfMemoKirim from "../../components/PdfMemoKirim/PdfMemoKirim";
import RefreshIcon from "../../Assets/refresh-icon.png";
import SearchLogo from "../../Assets/search-icon.png";
import DeleteIcon from "../../Assets/delete_icon.png";
import { fmt } from "./poHelpers";

export default function PoMemoTab({ po }) {
  const {
    checkingRole,
    filterDateMemoKirim,
    setFilterDateMemoKirim,
    valueSearchMemo,
    setValueSearchMemo,
    dataTempMemoSearch,
    dataMirrorMemoKirim,
    dataListCatatan,
    selectedMemoIds,
    handleToggleMemo,
    handleToggleAllMemo,
    handleBuatSuratJalan,
    handleExportExcel,
    setPopUpCatatan,
    setIsRefreshMantap,
    setIsRefreshMemoKirim,
    handleFormChangeEditNoPol,
    handleDeleteMemoKirim,
    handleSaveNoPol,
    disabledButton,
  } = po;

  // Memo Kirim = baris yang belum punya nomor surat jalan
  const rows = (dataTempMemoSearch || []).filter((e) => !e.noSj);
  const selectableIds = rows.filter((e) => !e.isBatal).map((e) => e._id);
  const allChecked =
    selectableIds.length > 0 &&
    selectableIds.every((id) => selectedMemoIds.includes(id));

  const total = rows.reduce((s, a) => s + a.jumlah, 0);
  const picked = rows.filter((e) => selectedMemoIds.includes(e._id));
  const pickedQty = picked.reduce((s, a) => s + a.jumlah, 0);

  const cetakMemo = async () => {
    // SJ yang dibatalkan penuh (jumlah 0) hanya catatan riwayat, jangan ikut tercetak
    const sorted = [...(dataMirrorMemoKirim || [])]
      .filter((e) => e.isBatal || Number(e.jumlah) > 0)
      .sort((a, b) => {
        if (a.noPol < b.noPol) return -1;
        if (a.noPol > b.noPol) return 1;
        if (a.itemPo > b.itemPo) return -1;
        if (a.itemPo < b.itemPo) return 1;
        return 0;
      });
    const blob = await pdf(
      <PdfMemoKirim
        data={sorted}
        catatan={dataListCatatan || []}
        date={filterDateMemoKirim}
      />
    ).toBlob();
    saveAs(
      blob,
      `MEMO KIRIM ${moment(filterDateMemoKirim)
        .utcOffset("+0700")
        .format("DD-MM-YY")}.pdf`
    );
  };

  return (
    <>
      <div className="po-toolbar">
        <div className="po-toolbar-group">
          <input
            className="po-input po-input--date"
            type="date"
            value={filterDateMemoKirim}
            onChange={(e) => setFilterDateMemoKirim(e.target.value)}
          />
          <div className="po-search">
            <input
              className="po-search-input"
              type="text"
              placeholder="Cari barang / No. PO"
              value={valueSearchMemo}
              onChange={(e) => setValueSearchMemo(e.target.value)}
            />
            <p className="po-search-icon">
              <img src={SearchLogo} alt="cari" />
            </p>
          </div>
          {checkingRole ? (
            <>
              <button
                className="po-btn po-btn--success po-btn--sm"
                onClick={handleExportExcel}
              >
                Export Excel
              </button>
              <button
                className="po-btn po-btn--gold po-btn--sm"
                onClick={() => setPopUpCatatan(true)}
              >
                Catatan
              </button>
            </>
          ) : null}
          <img
            className="po-refresh"
            src={RefreshIcon}
            alt="refresh"
            onClick={() => {
              setIsRefreshMantap(true);
              setIsRefreshMemoKirim(true);
            }}
          />
        </div>
        <div className="po-toolbar-group">
          <span className="po-summary">
            Dipilih <b>{picked.length}</b> item · <b>{fmt(pickedQty)}</b> pcs
          </span>
          <button
            className="po-btn po-btn--ghost po-btn--sm"
            onClick={cetakMemo}
          >
            Cetak Memo
          </button>
          {checkingRole ? (
            <button
              className="po-btn po-btn--danger"
              disabled={disabledButton || picked.length === 0}
              onClick={handleBuatSuratJalan}
            >
              Buat Surat Jalan
            </button>
          ) : null}
        </div>
      </div>

      <div className="po-table-wrap" style={{ maxHeight: "68vh" }}>
        <table className="po-table">
          <thead>
            <tr>
              <th className="po-th" style={{ width: 36 }}>
                <input
                  className="po-checkbox"
                  type="checkbox"
                  checked={allChecked}
                  onChange={() => handleToggleAllMemo(selectableIds)}
                />
              </th>
              <th className="po-th">No.</th>
              <th className="po-th">Cust</th>
              <th className="po-th">Nama Barang</th>
              <th className="po-th">Jml Pcs</th>
              <th className="po-th">No. PO</th>
              <th className="po-th">Line</th>
              <th className="po-th">No. SKK</th>
              <th className="po-th">No. Pol</th>
              <th className="po-th">Keterangan</th>
              <th className="po-th">Pelengkap</th>
              <th className="po-th" />
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td className="po-empty" colSpan={12}>
                  Tidak ada memo kirim yang menunggu surat jalan pada tanggal
                  ini.
                </td>
              </tr>
            ) : null}
            {rows.map((ele, index) => (
              <tr
                key={ele._id}
                className={`po-row ${index % 2 ? "po-row--alt" : ""} ${
                  ele.isBatal ? "po-row--cancelled" : ""
                }`}
              >
                <td className="po-td">
                  {!ele.isBatal ? (
                    <input
                      className="po-checkbox"
                      type="checkbox"
                      checked={selectedMemoIds.includes(ele._id)}
                      onChange={() => handleToggleMemo(ele._id)}
                    />
                  ) : null}
                </td>
                <td className="po-td">{index + 1}.</td>
                <td className="po-td">{ele.customer}</td>
                <td className="po-td">
                  {ele.customer === "YBI" ? ele.kodeBarang : ""} {ele.itemPo}
                </td>
                <td className="po-td po-nowrap">{fmt(ele.jumlah)}</td>
                <td className="po-td">{ele.noPo}</td>
                <td className="po-td po-nowrap">
                  {ele.noLine || ""}
                  {ele.kodeLine ? ` - ${ele.kodeLine}` : ""}
                </td>
                <td className="po-td">
                  {!ele.isBatal ? (
                    <input
                      className="po-input po-input--cell"
                      style={{ width: 96 }}
                      name="noSkk"
                      placeholder="SKK"
                      value={ele.noSkk || ""}
                      onChange={(e) =>
                        handleFormChangeEditNoPol(ele._id, e, "noSkk")
                      }
                    />
                  ) : null}
                </td>
                <td className="po-td">
                  {!ele.isBatal ? (
                    <input
                      className="po-input po-input--cell"
                      style={{ width: 84 }}
                      name="noPol"
                      value={ele.noPol || ""}
                      onChange={(e) =>
                        handleFormChangeEditNoPol(ele._id, e, "noPol")
                      }
                    />
                  ) : null}
                </td>
                <td className="po-td">
                  {!ele.isBatal ? (
                    <input
                      className="po-input po-input--cell"
                      style={{ width: 170 }}
                      name="keterangan"
                      type="text"
                      placeholder="Keterangan"
                      value={ele.keterangan || ""}
                      onChange={(e) =>
                        handleFormChangeEditNoPol(ele._id, e, "keterangan")
                      }
                    />
                  ) : null}
                </td>
                <td className="po-td">
                  {!ele.isBatal ? (
                    <input
                      className="po-checkbox"
                      name="isPelengkap"
                      type="checkbox"
                      checked={!!ele.isPelengkap}
                      onChange={(e) =>
                        handleFormChangeEditNoPol(ele._id, e, "isPelengkap")
                      }
                    />
                  ) : null}
                </td>
                <td className="po-td">
                  {checkingRole ? (
                    <img
                      className="po-icon-btn"
                      src={DeleteIcon}
                      alt="hapus"
                      onClick={() => handleDeleteMemoKirim(ele)}
                    />
                  ) : null}
                </td>
              </tr>
            ))}
            <tr className="po-foot">
              <td className="po-td" colSpan={4} style={{ textAlign: "right" }}>
                TOTAL KIRIMAN
              </td>
              <td className="po-td po-nowrap">{fmt(total)}</td>
              <td className="po-td" colSpan={7} />
            </tr>
          </tbody>
        </table>
      </div>

      {checkingRole ? (
        <div className="po-actions-end">
          <button className="po-btn po-btn--danger" onClick={handleSaveNoPol}>
            Update Memo
          </button>
        </div>
      ) : null}
    </>
  );
}
